var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForword1Active(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39369 14.1542C4.11077 14.3487 3.82078 14.3626 3.52372 14.1959C3.22666 14.0292 3.07812 13.7792 3.07812 13.4459V6.57091C3.07812 6.23757 3.22666 5.99091 3.52372 5.83091C3.82078 5.67146 4.11077 5.68202 4.39369 5.86257L9.65594 9.32091C9.91057 9.48757 10.0379 9.71674 10.0379 10.0084C10.0379 10.3001 9.91057 10.5292 9.65594 10.6959L4.39369 14.1542ZM12.8812 14.1542C12.5983 14.3487 12.3083 14.3626 12.0112 14.1959C11.7142 14.0292 11.5656 13.7792 11.5656 13.4459V6.57091C11.5656 6.23757 11.7142 5.99091 12.0112 5.83091C12.3083 5.67146 12.5983 5.68202 12.8812 5.86257L18.1434 9.32091C18.3981 9.48757 18.5254 9.71674 18.5254 10.0084C18.5254 10.3001 18.3981 10.5292 18.1434 10.6959L12.8812 14.1542Z",
    fill: "#8F4300",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForword1Active);
export default __webpack_public_path__ + "static/media/Forword1_active.2f6caa3e44af2cf249e44374929624f7.svg";
export { ForwardRef as ReactComponent };